import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { ToastContainer, Slide, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { ISettingsStore } from './services/settings/store';
import { IWithUserProps } from './services/withUser';
import { IStore } from './services/store';

import { MarketContextWrapper } from './services/contexts/markets/MarketProvider';
import { Header, Footer, AppLoading } from './components';
import { fetchSettings } from './services/settings/actionCreators';
import { ThemeProvider } from 'styled-components';
import Views from './views/index';
import Container from './components/Container';

interface IAppShellProps extends IWithUserProps {
  settings: ISettingsStore;
  fetchSettings: () => void;
}

interface IAppShellState {
  hasError: boolean;
}

class AppShell extends React.Component<IAppShellProps, IAppShellState> {
  state: IAppShellState = {
    hasError: false,
  };

  componentDidMount() {
    this.props.fetchSettings();
  }

  componentDidCatch(error: any, info: any) {
    this.setState({ hasError: true });
    console.log('SHELL ERROR', error, info);
    toast.error(`An error ocurred: ${error}`);
  }

  renderApp = (loading: boolean) => {
    const { settings, user } = this.props;
    return loading || settings.fetching ? (
      <AppLoading />
    ) : (
      <div className="text-black min-h-screen flex flex-col justify-between">
        <div>
          <Container>
            <Header
              user={user}
              appName={settings.applicationName}
              appLogoSrc={settings.styleHeaderImageUrl}
            />
          </Container>
          <Views />
        </div>
        <Container>
          <Footer
            showDataProtection={settings.customContentDataProtection}
            showImprint={settings.customContentImprint}
            version={settings.version}
          />
        </Container>
      </div>
    );
  };

  render() {
    const { settings } = this.props;
    return (
      <ThemeProvider theme={settings.theme}>
        <>
          <MarketContextWrapper>
            {(loading) => this.renderApp(loading)}
          </MarketContextWrapper>
          <ToastContainer transition={Slide} />
        </>
      </ThemeProvider>
    );
  }
}

const mapStateToProps = ({ settings, user }: IStore) => ({
  settings,
  user: {
    loggedIn: Boolean(user.username),
    username: user.username,
    roles: user.roles,
  },
});
const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, AnyAction>) => ({
  fetchSettings: () => dispatch(fetchSettings()),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AppShell) as any
);



// WEBPACK FOOTER //
// ./src/AppShell.tsx